import React from 'react';
import styles from './index.module.scss';

export default function Screen2() {
  return (
    <section className={styles['screen2-cover']}>
      <div className={styles['screen2-wrap']}>
        <h2 className={styles['screen2-title']}>关于我们</h2>
        <div className={styles['screen2-desc']}>
          <span className={styles['screen2-desc-text']}>爱学是北京与爱为舞科技有限公司旗下AI教育品牌，依托自研爱学大模型（国内领先的类真人音视频实时对话式教育大模型）、新一代数字人技术及自研语音大模型，我们开创性地打造了AI一对一教育范式，并致力于成为该领域的引领者。爱学以“爱与Al帮助每个人成为更好的自己”为品牌使命，致力于打造一个全时、全知、全能的终身学习AI智能体。
          </span>
          <span>我们打造的AI Tutor具备三重核心价值：</span>
          <span><span className={styles['screen2-desc-text-bold']}>真人级：</span>毫秒响应、情感理解、多模态融合的类人交互体验；</span>
          <span><span className={styles['screen2-desc-text-bold']}>大师级：</span>沉淀顶尖教育专家方法论，确保专业深度与权威性；</span>
          <span><span className={styles['screen2-desc-text-bold']}>专属级：</span>通过持续互动的长短期记忆与适配，实现终身成长的个性化陪伴。</span>
        </div>
      </div>
    </section>
  );
}
